import Axios, { AxiosInstance, AxiosResponse } from "axios";

/**
 * API client instance pre-configured with base URL and default headers.
 * In tests this module is mocked; in production it connects to the Laravel backend.
 */
class ApiClient {
  private axios: AxiosInstance;

  constructor() {
    this.axios = Axios.create({
      baseURL: import.meta.env.VITE_API_BASE_URL || "",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    // Attach Bearer token from localStorage on every request
    this.axios.interceptors.request.use((config) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });
  }

  async get<T = any>(url: string, params?: object): Promise<AxiosResponse<T>> {
    return this.axios.get<T>(url, { params });
  }

  async post<T = any>(url: string, data?: any): Promise<AxiosResponse<T>> {
    return this.axios.post<T>(url, data);
  }

  async patch<T = any>(url: string, data?: any): Promise<AxiosResponse<T>> {
    return this.axios.patch<T>(url, data);
  }

  async delete<T = any>(url: string): Promise<AxiosResponse<T>> {
    return this.axios.delete<T>(url);
  }
}

export const apiClient = new ApiClient();
